export class PredictedTimes {
  estimatedTimeEnrouteMinuteCnt: number = null;
  estimatedBlockTimeMinuteCnt: number = null;
}
